require('./stylesheet/index.scss');

angular.module('pages.yasnoP2P', [])
	.config(config);

config.$inject = ['$stateProvider'];
function config($stateProvider) {
	$stateProvider
		.state('pages.yasnoP2P', {
			url: 'yasnoP2P',
			template: require('./templates/index.html'),
			controller: require('../payment/controllers/payment'),
			data: {
				iframe: true
			},
			params: {
				fields: {},
				toEvent: null,//event to go to(for direct link to event) exmpl:pages.p2p({url:configs.p2ps_config.service.metallist, toEvent:32776496})
				serviceId: null,
				autoCheck: null,
				subscribe: null,
				amount: null,
				target:null,
				from_card_id: null,
				to_card_id: null,
				counters: null,
				account: null,
				lastDate: null,
				destination: null,
				templateId: null,
				editForbid: false,
                url: 'p2p'
			},
			pageTrack: 'yasnoP2P'
		});
}

module.exports = 'pages.yasnoP2P';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/yasnoP2P/index.js
 ** module id = 302
 ** module chunks = 1
 **/